var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuCardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-Framework",
    transform: "translate(-619.000000, -365.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9-Copy-3",
    transform: "translate(619.000000, 359.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Menu_Card_Active",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 L1,0 C0.447,0 0,0.447 0,1 L0,11 C0,11.553 0.447,12 1,12 L15,12 C15.553,12 16,11.553 16,11 L16,1 C16,0.447 15.553,0 15,0 Z",
    id: "Fill-1",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "14 10 2 10 2 5 14 5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "14 3 2 3 2 2 14 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,9 C12.553,9 13,8.553 13,8 C13,7.447 12.553,7 12,7 C11.447,7 11,7.447 11,8 C11,8.553 11.447,9 12,9 Z",
    id: "Path",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,9 C10.553,9 11,8.553 11,8 C11,7.447 10.553,7 10,7 C9.447,7 9,7.447 9,8 C9,8.553 9.447,9 10,9 Z",
    id: "Path",
    fill: "#212121"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuCardActive);
export default __webpack_public_path__ + "static/media/Icon-Menu_Card_Active.d70470c1c3b9ba4afea387a884df535b.svg";
export { ForwardRef as ReactComponent };